/* Period close. Paper and hairlines; tokens only (ADR-0007). State is a glyph and a word. */

.page {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.strip {
  display: flex;
  flex-wrap: wrap;
  gap: var(--gap);
  margin: 0;
  padding: 0;
  list-style: none;
}

.period {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 220px;
  padding: 10px 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.period:hover {
  border-color: var(--line-2);
  background: var(--panel-2);
}

.period[aria-pressed="true"] {
  border-color: var(--accent);
  background: var(--accent-w);
}

.period:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.periodName {
  font-size: var(--t-body);
  font-weight: 650;
}

.periodMeta {
  color: var(--muted);
  font-size: var(--t-min);
}

.cols {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: var(--gap);
  align-items: start;
}

.side {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.steps {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid var(--line);
}

.step:first-child {
  border-top: 0;
}

.mark {
  flex: none;
  color: var(--muted);
}

.step[data-state="done"] .mark {
  color: var(--ok);
}

.step[data-state="todo"] .mark {
  color: var(--crit);
}

.step[data-state="current"] .mark {
  color: var(--warn);
}

.stepText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.stepLabel {
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 600;
}

.stepWord {
  margin-left: 6px;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 500;
}

.stepDetail {
  color: var(--ink-2);
  font-size: var(--t-dense);
  overflow-wrap: anywhere;
}

.stepRemedy {
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  max-width: 70ch;
}

.stepLink {
  align-self: flex-start;
  color: var(--accent);
  font-size: var(--t-dense);
  font-weight: 650;
  text-decoration: underline;
}

.stepLink:focus-visible,
.lock:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.sentence {
  margin: 10px 0 0;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--line-2);
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.55;
}

.lock {
  margin-top: 12px;
  min-height: 34px;
  padding: 0 14px;
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 650;
  cursor: pointer;
}

.lock:hover:not(:disabled) {
  background: var(--accent-h);
}

.lock:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.fine {
  margin: 8px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
}

@media (width <= 1000px) {
  .cols {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (width <= 560px) {
  .period {
    min-width: 0;
    width: 100%;
  }

  .lock {
    min-height: var(--target-touch);
  }
}
